import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const organizationwebsite = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/organization-web-site',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'organizationwebsite' }
    ),
    { }
  )
)()

export { organizationwebsite, TYPES }
